/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LabelItemDto } from './labelItemDto';
import { AttachmentDetailDto } from './attachmentDetailDto';


export interface SensorItemDto { 
    id: string;
    name: string;
    color: string;
    icon?: AttachmentDetailDto;
    sensorUnit: SensorItemDto.SensorUnitEnum;
    effectiveUnit: SensorItemDto.EffectiveUnitEnum;
    sensorMetricKind: SensorItemDto.SensorMetricKindEnum;
    isActive: boolean;
    sensorSyncStatus: SensorItemDto.SensorSyncStatusEnum;
    sensorCleanStatus: SensorItemDto.SensorCleanStatusEnum;
    syncBlockedReason?: SensorItemDto.SyncBlockedReasonEnum;
    label?: LabelItemDto;
    purpose: SensorItemDto.PurposeEnum;
    lastSensorValue?: number;
    lastSensorValueTimestamp?: string;
    sensorBlockId: string;
    sensorBlockName: string;
    sensorIntegrationType: SensorItemDto.SensorIntegrationTypeEnum;
    linkedUnitName?: string;
    anchorValue?: number;
    anchorTimestamp?: string;
}
export namespace SensorItemDto {
    export type SensorUnitEnum = 'DEGREE_CELSIUS' | 'DEGREE_KELVIN' | 'MEGAWATT_HOUR' | 'KILOWATT_HOUR' | 'WATT' | 'KILOWATT' | 'MEGAWATT' | 'CUBIC_METER' | 'CUBIC_CENTIMETER' | 'CUBIC_METER_PER_HOUR' | 'LITER' | 'LITER_PER_HOUR' | 'BAR' | 'PASCAL' | 'PERCENT' | 'PARTS_PER_MILLION' | 'VOLT' | 'AMPERE' | 'HERTZ' | 'NONE';
    export const SensorUnitEnum = {
        DegreeCelsius: 'DEGREE_CELSIUS' as SensorUnitEnum,
        DegreeKelvin: 'DEGREE_KELVIN' as SensorUnitEnum,
        MegawattHour: 'MEGAWATT_HOUR' as SensorUnitEnum,
        KilowattHour: 'KILOWATT_HOUR' as SensorUnitEnum,
        Watt: 'WATT' as SensorUnitEnum,
        Kilowatt: 'KILOWATT' as SensorUnitEnum,
        Megawatt: 'MEGAWATT' as SensorUnitEnum,
        CubicMeter: 'CUBIC_METER' as SensorUnitEnum,
        CubicCentimeter: 'CUBIC_CENTIMETER' as SensorUnitEnum,
        CubicMeterPerHour: 'CUBIC_METER_PER_HOUR' as SensorUnitEnum,
        Liter: 'LITER' as SensorUnitEnum,
        LiterPerHour: 'LITER_PER_HOUR' as SensorUnitEnum,
        Bar: 'BAR' as SensorUnitEnum,
        Pascal: 'PASCAL' as SensorUnitEnum,
        Percent: 'PERCENT' as SensorUnitEnum,
        PartsPerMillion: 'PARTS_PER_MILLION' as SensorUnitEnum,
        Volt: 'VOLT' as SensorUnitEnum,
        Ampere: 'AMPERE' as SensorUnitEnum,
        Hertz: 'HERTZ' as SensorUnitEnum,
        None: 'NONE' as SensorUnitEnum
    };
    export type EffectiveUnitEnum = 'DEGREE_CELSIUS' | 'DEGREE_KELVIN' | 'MEGAWATT_HOUR' | 'KILOWATT_HOUR' | 'WATT' | 'KILOWATT' | 'MEGAWATT' | 'CUBIC_METER' | 'CUBIC_CENTIMETER' | 'CUBIC_METER_PER_HOUR' | 'LITER' | 'LITER_PER_HOUR' | 'BAR' | 'PASCAL' | 'PERCENT' | 'PARTS_PER_MILLION' | 'VOLT' | 'AMPERE' | 'HERTZ' | 'NONE';
    export const EffectiveUnitEnum = {
        DegreeCelsius: 'DEGREE_CELSIUS' as EffectiveUnitEnum,
        DegreeKelvin: 'DEGREE_KELVIN' as EffectiveUnitEnum,
        MegawattHour: 'MEGAWATT_HOUR' as EffectiveUnitEnum,
        KilowattHour: 'KILOWATT_HOUR' as EffectiveUnitEnum,
        Watt: 'WATT' as EffectiveUnitEnum,
        Kilowatt: 'KILOWATT' as EffectiveUnitEnum,
        Megawatt: 'MEGAWATT' as EffectiveUnitEnum,
        CubicMeter: 'CUBIC_METER' as EffectiveUnitEnum,
        CubicCentimeter: 'CUBIC_CENTIMETER' as EffectiveUnitEnum,
        CubicMeterPerHour: 'CUBIC_METER_PER_HOUR' as EffectiveUnitEnum,
        Liter: 'LITER' as EffectiveUnitEnum,
        LiterPerHour: 'LITER_PER_HOUR' as EffectiveUnitEnum,
        Bar: 'BAR' as EffectiveUnitEnum,
        Pascal: 'PASCAL' as EffectiveUnitEnum,
        Percent: 'PERCENT' as EffectiveUnitEnum,
        PartsPerMillion: 'PARTS_PER_MILLION' as EffectiveUnitEnum,
        Volt: 'VOLT' as EffectiveUnitEnum,
        Ampere: 'AMPERE' as EffectiveUnitEnum,
        Hertz: 'HERTZ' as EffectiveUnitEnum,
        None: 'NONE' as EffectiveUnitEnum
    };
    export type SensorMetricKindEnum = 'GAUGE' | 'DELTA' | 'CUMULATIVE';
    export const SensorMetricKindEnum = {
        Gauge: 'GAUGE' as SensorMetricKindEnum,
        Delta: 'DELTA' as SensorMetricKindEnum,
        Cumulative: 'CUMULATIVE' as SensorMetricKindEnum
    };
    export type SensorSyncStatusEnum = 'INIT' | 'QUEUED' | 'SYNCING' | 'SYNCED' | 'FAILED' | 'DISABLED';
    export const SensorSyncStatusEnum = {
        Init: 'INIT' as SensorSyncStatusEnum,
        Queued: 'QUEUED' as SensorSyncStatusEnum,
        Syncing: 'SYNCING' as SensorSyncStatusEnum,
        Synced: 'SYNCED' as SensorSyncStatusEnum,
        Failed: 'FAILED' as SensorSyncStatusEnum,
        Disabled: 'DISABLED' as SensorSyncStatusEnum
    };
    export type SensorCleanStatusEnum = 'IDLE' | 'QUEUED' | 'CLEANING' | 'CLEANED' | 'FAILED';
    export const SensorCleanStatusEnum = {
        Idle: 'IDLE' as SensorCleanStatusEnum,
        Queued: 'QUEUED' as SensorCleanStatusEnum,
        Cleaning: 'CLEANING' as SensorCleanStatusEnum,
        Cleaned: 'CLEANED' as SensorCleanStatusEnum,
        Failed: 'FAILED' as SensorCleanStatusEnum
    };
    export type SyncBlockedReasonEnum = 'NO_INTEGRATION' | 'MISSING_CONTROL_SYSTEM' | 'AMBIGUOUS_CONTROL_SYSTEM' | 'INVALID_CONTROL_SYSTEM' | 'MISSING_FUNCTION_BLOCK' | 'INVALID_FUNCTION_BLOCK' | 'MISSING_FB_ADDRESS' | 'AMBIGUOUS_CON_ID';
    export const SyncBlockedReasonEnum = {
        NoIntegration: 'NO_INTEGRATION' as SyncBlockedReasonEnum,
        MissingControlSystem: 'MISSING_CONTROL_SYSTEM' as SyncBlockedReasonEnum,
        AmbiguousControlSystem: 'AMBIGUOUS_CONTROL_SYSTEM' as SyncBlockedReasonEnum,
        InvalidControlSystem: 'INVALID_CONTROL_SYSTEM' as SyncBlockedReasonEnum,
        MissingFunctionBlock: 'MISSING_FUNCTION_BLOCK' as SyncBlockedReasonEnum,
        InvalidFunctionBlock: 'INVALID_FUNCTION_BLOCK' as SyncBlockedReasonEnum,
        MissingFbAddress: 'MISSING_FB_ADDRESS' as SyncBlockedReasonEnum,
        AmbiguousConId: 'AMBIGUOUS_CON_ID' as SyncBlockedReasonEnum
    };
    export type PurposeEnum = 'ROOT_METER' | 'UNIT_METER' | 'MONITORING';
    export const PurposeEnum = {
        RootMeter: 'ROOT_METER' as PurposeEnum,
        UnitMeter: 'UNIT_METER' as PurposeEnum,
        Monitoring: 'MONITORING' as PurposeEnum
    };
    export type SensorIntegrationTypeEnum = 'NONE' | 'REISENBAUER_ENERGY_METER' | 'REISENBAUER_SENSOR';
    export const SensorIntegrationTypeEnum = {
        None: 'NONE' as SensorIntegrationTypeEnum,
        ReisenbauerEnergyMeter: 'REISENBAUER_ENERGY_METER' as SensorIntegrationTypeEnum,
        ReisenbauerSensor: 'REISENBAUER_SENSOR' as SensorIntegrationTypeEnum
    };
}


